import { MemeTemplateTextBox } from "types/meme";
import { DEFAULT_MEME_TEXT } from "../data/defaultMemeText";
import { TextBoxStates } from "../types";
import { getTextBoxDefaultStyles } from "./getTextBoxDefaultStyles";

export const getInitialTextBoxSettings = (
    textBox: Pick<
        MemeTemplateTextBox,
        | "width"
        | "height"
        | "left"
        | "top"
        | "rotation"
        | "font"
        | "fontColor"
        | "verticalAlign"
        | "textAlign"
        | "forceCaps"
    >,
    id: string,
) => {
    return {
        id,
        ...textBox,
        value: DEFAULT_MEME_TEXT,
        innerHTML: DEFAULT_MEME_TEXT,
        ...getTextBoxDefaultStyles({
            fontColor: textBox.fontColor,
            verticalAlign: textBox.verticalAlign,
            textAlign: textBox.textAlign,
            forceCaps: textBox.forceCaps,
            font: textBox.font || "Impact",
        }),
        state: TextBoxStates.BLUR,
    };
};
